import { createReducer } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { createTableQueryReducers } from '@/store/queryReducers';
import t from '@/store/types';

const initialState: {
  items: Record<string, any>;
  userById: Record<string, any>;
  loading: boolean;
} = {
  items: {},
  userById: {},
  loading: false,
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.USERS_LIST_SET, (state, action: AnyAction) => {
    const { users } = action.payload;
    const _users: Record<string, any> = {};

    users.forEach((user: any) => {
      _users[user.id] = {
        ...user,
      };
    });
    state.items = {
      ...state.items,
      ..._users,
    };
  });

  builder.addCase(t.USER_DETAILS_SET, (state, action: AnyAction) => {
    const { id, user } = action.payload;
    const _user = state.items[id] || {};
    state.items[id] = { ..._user, ...user };
  });

  builder.addCase(t.USERS_TABLE_LOADING, (state, action: AnyAction) => {
    const { loading } = action.payload;
    state.loading = loading;
  });
  builder.addCase(t.USER_DELETE, (state, action: AnyAction) => {
    const { id } = action.payload;
    if (typeof state.items[id] !== 'undefined') {
      delete state.items[id];
    }
  });

  Object.entries(createTableQueryReducers('USERS') as any).forEach(
    ([actionType, reducer]) => {
      builder.addCase(actionType, reducer as any);
    },
  );
});

/**
 * Retrieve the user details of the given user id,
 * @param {Object} state
 * @param {Numeric} id
 */
export const getUserDetails = (state: any, id: any) => {
  return state.users.userById[id];
};
